import classNames from 'classnames';
import React, { forwardRef, useState } from 'react';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './Textarea.module.scss';
const Textarea = forwardRef(({ size = 'l', shape = 'block', color = 'primary', disabled = false, placeholder = '', name, value, rows = 3, loading = false, testId, error, onChange, onKeyDown, onFocus, onBlur, }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const textareaClasses = classNames(styles.textarea, styles[size], styles[shape], styles[color], {
        [styles.error]: error,
    });
    const handleFocus = () => {
        setIsFocused(true);
        if (onFocus) {
            onFocus();
        }
    };
    const handleBlur = () => {
        setIsFocused(false);
        if (onBlur) {
            setTimeout(() => onBlur(), 300);
        }
    };
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("textarea", { name: name, value: value, placeholder: placeholder, className: textareaClasses, "data-test": testId, onChange: onChange, onKeyDown: onKeyDown, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled, rows: rows, ref: ref }),
        loading && isFocused && (React.createElement("div", { className: styles.loadingIcon },
            React.createElement(LoaderSvg, null)))));
});
export default Textarea;
